import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import { LanguageProvider } from "./context/LanguageContext";
import HomePage from "./pages/HomePage";
import ImpressumPage from "./pages/ImpressumPage";
import DatenschutzPage from "./pages/DatenschutzPage";
import AdminPage from "./pages/AdminPage";
import BlogListPage from "./pages/BlogListPage";
import BlogDetailPage from "./pages/BlogDetailPage";
import FAQPage from "./pages/FAQPage";
import ScrollToTop from "./components/ScrollToTop";
import CookieBanner from "./components/CookieBanner";
import BackToTop from "./components/BackToTop";
import WhatsAppWidget from "./components/WhatsAppWidget";
import PageTracker from "./components/PageTracker";
import LoadingScreen from "./components/LoadingScreen";

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <div className="App min-h-screen bg-white dark:bg-gray-900 transition-colors duration-300">
          <LoadingScreen />
          <BrowserRouter>
            <ScrollToTop />
            <PageTracker />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/impressum" element={<ImpressumPage />} />
              <Route path="/datenschutz" element={<DatenschutzPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/blog" element={<BlogListPage />} />
              <Route path="/blog/:postId" element={<BlogDetailPage />} />
              <Route path="/faq" element={<FAQPage />} />
            </Routes>
            <CookieBanner />
            <WhatsAppWidget />
            <BackToTop />
          </BrowserRouter>
        </div>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
